import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Grid,
  Paper,
} from '@material-ui/core';

import '../../assets/stylesheets/BookingForm.css';
import BookingFormHeader from './BookingFormHeader';
import BookingFormEmployeeInput from './BookingFormEmployeeInput';
import BookingFormProductTierInfo from './BookingFormProductTierInfo';
import BookingFormTwoItemRowInfo from './BookingFormTwoItemRowInfo';
import SpecialProjectInfo from './SpecialProjectInfo';

class BookingFormBasic extends Component {
  render() {
    const {
      locationId,
      locationName,
      handleSave,
      items,
      productTier,
      isSpecialProject,
      specialProject,
      onFormEmployeeSelect,
      showEmployeesOfPosition,
      requiredPositions,
    } = this.props;

    return (
      <Paper className="bookingForm">
        <Grid container spacing={0}>
          <BookingFormHeader
            locationId={locationId}
            locationName={locationName}
            handleSave={handleSave}
          />
          {items !== null && (
            <BookingFormTwoItemRowInfo
              items={items}
            />
          )}
          {productTier !== null && (
            <BookingFormProductTierInfo productTier={productTier} />
          )}
          {isSpecialProject && (
            <SpecialProjectInfo specialProject={specialProject} />
          )}
          {requiredPositions.map(position =>
            <BookingFormEmployeeInput
              key={position.positionTitle}
              eligibleEmployees={position.eligibleEmployees}
              onFormEmployeeSelect={onFormEmployeeSelect}
              showEmployeesOfPosition={showEmployeesOfPosition}
              positionTitle={position.positionTitle}
              label={position.positionLabel}
            />)
          }
        </Grid>
      </Paper>
    )
  }
}

BookingFormBasic.defaultProps = {
  specialProject: false,
  items: null,
  productTier: null,
};

BookingFormBasic.propTypes = {
  locationId: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  productTier: PropTypes.number,
  isSpecialProject: PropTypes.bool.isRequired,
  specialProject: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape([PropTypes.string, PropTypes.number])]),
  onFormEmployeeSelect: PropTypes.func.isRequired,
  showEmployeesOfPosition: PropTypes.func.isRequired,
  requiredPositions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default BookingFormBasic;
